const unique = (items)=>Array.from(new Set(items));
const byName = (a, b)=>a.name.localeCompare(b.name);
export const getContinents = (regions)=>{
    const codes = unique(regions.map((region)=>region.continentCode));
    return codes.map((code)=>({
            code: code,
            name: nameForContinent(regions, code)
        })).sort(byName);
};
export const getCountriesOfContinent = (regions, continent)=>{
    if (continent == '') return [];
    const inContinent = regions.filter((region)=>region.continentCode == continent);
    const codes = unique(inContinent.map((region)=>region.countryCode));
    return codes.map((code)=>({
            code: code,
            name: nameForCountry(inContinent, code)
        })).sort(byName);
};
export const getRegionsOfCountry = (regions, country)=>{
    if (country == '') return [];
    return regions.filter((region)=>region.countryCode == country).sort((a, b)=>a.regionName.localeCompare(b.regionName));
};
const nameForContinent = (regions, code)=>{
    var _regions_find;
    var _regions_find_continentName;
    return (_regions_find_continentName = (_regions_find = regions.find((region)=>region.continentCode == code)) === null || _regions_find === void 0 ? void 0 : _regions_find.continentName) !== null && _regions_find_continentName !== void 0 ? _regions_find_continentName : code;
};
const nameForCountry = (regions, code)=>{
    var _regions_find;
    var _regions_find_countryName;
    return (_regions_find_countryName = (_regions_find = regions.find((region)=>region.countryCode == code)) === null || _regions_find === void 0 ? void 0 : _regions_find.countryName) !== null && _regions_find_countryName !== void 0 ? _regions_find_countryName : code;
};
